export default __webpack_public_path__ + "static/media/element_41.012d6192.webp";